import { Avatar, BendBigCircle, FlatButton, GreenChevronsRight } from '@bendhealth/common';
import { Text } from 'components/core/text/Text';
import { format } from 'date-fns';

import { AppointmentStatus, AppointmentTypes } from '../../../../../components/_temp_ui_common/Appointments/types';
import { AlignCenter, ScheduleBarDesktop, ScheduleBarMobile } from './styled';

export interface AppointmentItemProps {
  name: string;
  duration: number;
  selected: boolean;
  disabled?: boolean;
  scheduledDateTime?: string;
  status: AppointmentStatus;
  appointmentType: AppointmentTypes;
  credentialedName: string | null;
  avatarUrlSmall: string | null;
  onClick: () => void;
}

export const AppointmentItem = ({
  name,
  status,
  duration,
  selected,
  disabled,
  scheduledDateTime,
  appointmentType,
  onClick,
  avatarUrlSmall,
  credentialedName,
}: AppointmentItemProps) => {
  const formattedScheduledTime = scheduledDateTime
    ? format(new Date(scheduledDateTime), 'E, MMM d | h:mmaaa')
    : undefined;

  return (
    <>
      <ScheduleBarDesktop selected={selected} onClick={disabled ? undefined : onClick} className="row clickable">
        <div className="left">
          <Avatar appointmentType={appointmentType} name={credentialedName} url={avatarUrlSmall} />
          <div>
            <Text variant="text4" bold style={{ lineHeight: '21.6px' }} data-testid="appointment-name">
              {name}
            </Text>
            <Text variant="text6">{duration}&nbsp;mins</Text>
          </div>
        </div>
        <AlignCenter>
          {selected && !disabled && status != AppointmentStatus.Scheduled ? (
            <>
              <Text variant="text6" color="green6" className="pr-2">
                Scheduling
              </Text>
              <GreenChevronsRight />
            </>
          ) : formattedScheduledTime ? (
            <Text variant="text6" className="pr-2" data-testid="scheduled-at">
              {formattedScheduledTime}
            </Text>
          ) : (
            <FlatButton disabled={disabled} data-testid="schedule-button">
              Schedule
            </FlatButton>
          )}
        </AlignCenter>
      </ScheduleBarDesktop>

      <ScheduleBarMobile selected={selected} onClick={disabled ? undefined : onClick}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <BendBigCircle width="45px" height="45px" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              paddingLeft: 12,
            }}
          >
            <Text bold>{name}</Text>
            <Text variant="text6">{duration}&nbsp;mins</Text>
          </div>
        </div>
        {formattedScheduledTime ? (
          <Text variant="text6" className="pr-2">
            {formattedScheduledTime}
          </Text>
        ) : (
          <FlatButton disabled={disabled} data-testid="schedule-button">
            Schedule
          </FlatButton>
        )}
      </ScheduleBarMobile>
    </>
  );
};
